export const cepMask = '#####-###';
